export type SatelliteWaterQuality = {
  secchiDepthM: number | null;
  chlorophyllMgM3: number | null;
  spmGM3: number | null;
  sstC: number | null;
  dissolvedOxygenMlL: number | null;
  nitrateMmolM3: number | null;
  phosphateMmolM3: number | null;
  date: string;
  dataSource: string;
};

export type SecchiLabel = "excellent" | "good" | "moderate" | "poor";

export function classifySecchi(depthM: number): SecchiLabel {
  if (depthM >= 15) return "excellent";
  if (depthM >= 8) return "good";
  if (depthM >= 3) return "moderate";
  return "poor";
}

export function secchiBadgeConfig(label: SecchiLabel): {
  bg: string;
  text: string;
  border: string;
} {
  switch (label) {
    case "excellent":
      return { bg: "bg-emerald-50", text: "text-emerald-800", border: "border-emerald-200" };
    case "good":
      return { bg: "bg-teal-50", text: "text-teal-800", border: "border-teal-200" };
    case "moderate":
      return { bg: "bg-amber-50", text: "text-amber-800", border: "border-amber-200" };
    case "poor":
      return { bg: "bg-red-50", text: "text-red-800", border: "border-red-200" };
  }
}

export function secchiBadgeText(label: SecchiLabel): string {
  switch (label) {
    case "excellent": return "Crystal clear water";
    case "good": return "Good water clarity";
    case "moderate": return "Moderate water clarity";
    case "poor": return "Reduced water clarity";
  }
}
